/* src/app/send-reflections/send-reflections.component.scss */
.page {
  width: 60%;
  display: block;
  margin: 0 auto;
  text-align: left;
}
.page p {
  margin-bottom: 20px;
}
/*# sourceMappingURL=send-reflections.component.css.map */
